import {
    SliceFactory,
    FetchCollectionData,
    ApiCollectionResponse,
    FetchItemDataType,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters as FormalityApiConfigurationParameters,
    Configuration,
    ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierRead,
    ValideursDesDossiersApi,
    ValideursDesDossiersApiApiDossiersValideursGetCollectionRequest,
    ValideursDesDossiersApiApiDossiersValideursIdGetRequest,
} from '../../../openApi/ApiFormalite';
import { DOSSIER_VALIDATOR_SLICE_NAME, FORMALITES_REDUCER_NAME } from '../constants';

export type DossierValidatorApiObject =
    ValideursDesDossiersDossierValidatorResponseDtoValidatorsDossierRead & Record<string, unknown>;

export type DossierValidator = DossierValidatorApiObject;

export const mapperDossierValidators = function (validators: DossierValidator) {
    return {
        ...validators,
    } as DossierValidator;
};

export function createDossierValidatorSlice(configuration: FormalityApiConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new ValideursDesDossiersApi(conf);

    const fetchDossierValidatorCollection: FetchCollectionData<DossierValidator> = ({
        pagination,
    }) => {
        const options = undefined;
        const requestParameters: ValideursDesDossiersApiApiDossiersValideursGetCollectionRequest = {
            page: pagination.page + 1,
            itemsPerPage: 100,
        };

        return api
            .apiDossiersValideursGetCollection(requestParameters, options)
            .then((res) => res.data) as Promise<ApiCollectionResponse<DossierValidator>>;
    };

    const fetchDossierValidatorItem: FetchItemDataType<DossierValidator> = ({ idItem }) => {
        const requestParameters: ValideursDesDossiersApiApiDossiersValideursIdGetRequest = {
            id: String(idItem),
        };

        return api
            .apiDossiersValideursIdGet(requestParameters)
            .then((res) => res.data) as Promise<DossierValidator>;
    };

    const { slice: dossierValidatorSlice, dataSourcesThunks: dossierValidatorDataSourcesThunks } =
        SliceFactory.createSlice<DossierValidator, DossierValidator>(
            DOSSIER_VALIDATOR_SLICE_NAME,
            FORMALITES_REDUCER_NAME,
            [],
            fetchDossierValidatorCollection,
            fetchDossierValidatorItem,
            mapperDossierValidators,
            {},
        );

    return { dossierValidatorSlice, dossierValidatorDataSourcesThunks };
}
